/**
 * Enum keys used by `checkDateRelativeness` — describes whether a timestamp
 * sits in the past, in the future, or "now" (within ±30 seconds).
 */
export const dateRelativness = {
	now: 'now',
	future: 'future',
	past: 'past',
};

/**
 * Canonical US timezone entries used by the Timezone selectors. Values are
 * IANA zone names; names are the human-facing labels.
 */
export const TIME_ZONES_STANDARD = {
	usEastern: {
		name: 'Eastern Standard Time, Washington DC (GMT-5)',
		value: 'US/Eastern',
	},
	usCentral: {
		name: 'Central Standard Time, Chicago (GMT-6)',
		value: 'US/Central',
	},
	usDenver: {
		name: 'Mountain Standard Time, Denver (GMT-7)',
		value: 'America/Denver',
	},
	usPhoenix: {
		name: 'Mountain Standard Time, Phoenix (GMT-7)',
		value: 'America/Phoenix',
	},
	usPacific: {
		name: 'Pacific Standard Time, Los Angeles (GMT-8)',
		value: 'US/Pacific',
	},
};

/**
 * Extra timezone selector entries that aren't part of the canonical US set:
 *   - `myTime` — the user's guessed local zone. Resolved via
 *     `Intl.DateTimeFormat` once at module load, so this snapshot is fixed
 *     for the session (browser tz changes don't update it).
 *   - `mockGarageTime` — hard-pinned to US/Central; used for demo/testing.
 *   - `stationTime` — `null` sentinel meaning "use the station's own tz".
 */
export const TIME_ZONES_ADDITIONS = {
	myTime: {
		name: 'My Time',
		value: Intl.DateTimeFormat().resolvedOptions().timeZone,
	},
	mockGarageTime: {
		name: 'Garage time',
		value: 'US/Central',
	},
	stationTime: {
		name: 'Station time',
		value: null,
	},
};
